import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { ApiResponse } from '@Types/Api';
import type { Query } from '@Types/Base';

async function getVisit({ url }, request: Query) {
  const crmUrl = `/web-crm/api${url}`;

  const res = await Api.queryProxi<ApiResponse<void>>(crmUrl, {}, request);

  if (!res.ok) throw new BackendError(url, res);

  return res.data;
}

export default getVisit;
